import { Suspense } from 'react'
import styled from 'styled-components'
import { calculateAge } from 'utils/age/calculateAge'
import Field from '../../../../fields'
import { ALLERGY_OPTIONS } from '../constants'
import EditProfileCard, { CardFields, segmentedRadio } from '../EditProfileCard'

const DobRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`
const DobInput = styled.div`
  width: 288px;
`
const Age = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  font-weight: 500;
  color: ${({ theme }) => theme.color.neutral.color3};
`
const AgeValue = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  padding: 4px 8px;
  border-radius: 4px;
  background: #e9ecef;
  font-weight: 500;
`

type PersonalDetailsCardProps = {
  fields: Record<string, any>
  formId: string
  testId?: string
}

const PersonalDetailsCard = ({
  fields,
  formId,
  testId
}: PersonalDetailsCardProps) => {
  const age = calculateAge(fields.dateOfBirth)

  return (
    <EditProfileCard title="Personal details" testId={testId}>
      <Suspense fallback={<div>Loading...</div>}>
        <CardFields>
          <DobRow>
            <DobInput>
              <Field
                className="dateofbirth-field"
                keys="dateOfBirth"
                placeholders="DD-MM-YYYY"
                formId={formId}
                label="Date of Birth"
                type="birthdate"
                validationTypes="birthdate"
                values={fields}
              />
            </DobInput>
            {age !== null && (
              <Age data-testid="derived-age">
                Age <AgeValue>{age}</AgeValue>
              </Age>
            )}
          </DobRow>
          <Field
            className="address-field"
            formId={formId}
            keys="address"
            label="Address"
            type="address"
            values={fields}
          />
          <Field
            className="phonenumber-field"
            formId={formId}
            keys="phoneNumber"
            label="Personal Telephone Number"
            options={{ phone: true, phoneRegionCode: 'GB' }}
            type="formattedText"
            values={fields}
          />
          <Field
            className="allergies-field"
            keys="hasAllergies"
            label="Allergies"
            formId={formId}
            options={ALLERGY_OPTIONS}
            type="radios"
            values={fields}
            {...segmentedRadio}
          />
          <Field
            dependsOn={{ key: 'hasAllergies', value: 'Yes' }}
            keys="allergies"
            required
            label="Allergy Details"
            formId={formId}
            type="text"
            values={fields}
          />
        </CardFields>
      </Suspense>
    </EditProfileCard>
  )
}

export default PersonalDetailsCard
